import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [SpinnerComponent],
  imports: [CommonModule, PipesModule],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
